export const shadows = {
  Shadows: {
    xs: {
      $type: "shadow",
      $value: [
        {
          offsetX: "0px",
          offsetY: "1px",
          blur: "2px",
          spread: "0px",
          color: "{Effect.Shadows.shadow-xs}",
        },
      ],
    },
    sm: {
      $type: "shadow",
      $value: [
        {
          offsetX: "0px",
          offsetY: "1px",
          blur: "2px",
          spread: "0px",
          color: "{Effect.Shadows.shadow-sm_2}",
        },
        {
          offsetX: "0px",
          offsetY: "1px",
          blur: "3px",
          spread: "0px",
          color: "{Effect.Shadows.shadow-sm_1}",
        },
      ],
    },
    md: {
      $type: "shadow",
      $value: [
        {
          offsetX: "0px",
          offsetY: "2px",
          blur: "4px",
          spread: "-2px",
          color: "{Effect.Shadows.shadow-md_2}",
        },
        {
          offsetX: "0px",
          offsetY: "4px",
          blur: "8px",
          spread: "-2px",
          color: "{Effect.Shadows.shadow-md_1}",
        },
      ],
    },
    lg: {
      $type: "shadow",
      $value: [
        {
          offsetX: "0px",
          offsetY: "4px",
          blur: "6px",
          spread: "-2px",
          color: "{Effect.Shadows.shadow-lg_2}",
        },
        {
          offsetX: "0px",
          offsetY: "12px",
          blur: "16px",
          spread: "-4px",
          color: "{Effect.Shadows.shadow-lg_1}",
        },
      ],
    },
    xl: {
      $type: "shadow",
      $value: [
        {
          offsetX: "0px",
          offsetY: "8px",
          blur: "8px",
          spread: "-4px",
          color: "{Effect.Shadows.shadow-xl_2}",
        },
        {
          offsetX: "0px",
          offsetY: "20px",
          blur: "24px",
          spread: "-4px",
          color: "{Effect.Shadows.shadow-xl_1}",
        },
      ],
    },
    "2xl": {
      $type: "shadow",
      $value: [
        {
          offsetX: "0px",
          offsetY: "24px",
          blur: "48px",
          spread: "-12px",
          color: "{Effect.Shadows.shadow-2xl}",
        },
      ],
    },
    "3xl": {
      $type: "shadow",
      $value: [
        {
          offsetX: "0px",
          offsetY: "32px",
          blur: "64px",
          spread: "-12px",
          color: "{Effect.Shadows.shadow-3xl}",
        },
      ],
    },
  },
  "Background Blur": {
    sm: {
      $type: "shadow",
      $value: [
        {
          backgroundBlur: true,
          blur: "8px",
        },
      ],
    },
    md: {
      $type: "shadow",
      $value: [
        {
          backgroundBlur: true,
          blur: "16px",
        },
      ],
    },
    lg: {
      $type: "shadow",
      $value: [
        {
          backgroundBlur: true,
          blur: "24px",
        },
      ],
    },
    xl: {
      $type: "shadow",
      $value: [
        {
          backgroundBlur: true,
          blur: "40px",
        },
      ],
    },
  },
};
